import { atom } from "jotai";
import type { ILayoutStylesStore } from "../../../types/layout/layout-styles.type";

export const layoutStylesStoreInitialState: ILayoutStylesStore = {};

export const LayoutStylesStore = atom<ILayoutStylesStore>(layoutStylesStoreInitialState);
